const getActionLevelTooltip = (level: string) => {
  return `Can be used only in rules with ${level.toUpperCase()} level`;
};

export default getActionLevelTooltip;
